import React, { useState } from 'react';
import { motion } from 'framer-motion';

/**
 * LazyImage Component
 * Prevents "part-by-part" loading by showing a placeholder and 
 * fading in the image only once it's fully loaded.
 */
const LazyImage = ({ src, alt, className,placeholderImage=null,  priority = false, ...props }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <div className={`relative overflow-hidden bg-gray-100 ${className}`}>
      {/* Placeholder - static background color, fades out */}

      {
        placeholderImage ? (

                  <motion.img
          src={placeholderImage}
          alt="blur placeholder"
          initial={{ opacity: 1 }}
          animate={{ opacity: isLoaded ? 0 : 1 }}
          transition={{ duration: 0.3 }}
          className="absolute inset-0 w-full h-full object-cover blur-md scale-110 z-10"
        />
        ):(
          <motion.div
            initial={{ opacity: 1 }}
            animate={{ opacity: isLoaded ? 0 : 1 }}
            transition={{ duration: 0.3 }}
            className="absolute inset-0 bg-gray-200 z-10"
            style={{ pointerEvents: 'none' }}
          />
        )
      }

      {/* Actual Image */}
      <motion.img
        src={src}
        alt={alt}
        initial={{ opacity: 0 }}
        animate={{ opacity: isLoaded ? 1 : 0 }}
        transition={{ duration: 0.3, ease: "easeOut" }}
        onLoad={() => setIsLoaded(true)}
        className="w-full h-full object-cover"
        loading={priority ? "eager" : "lazy"}
        {...props}
      />
    </div>
  );
};

export default LazyImage;
